import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useLocation } from "react-router-dom";

export const useGetActiveChapterHash = () => {
  const { hash } = useLocation();
  // When using next JS it is safer to have a fallback of the window hash
  // for initial page load
  const windowHash = getWindowOrThrow().location.hash;
  return hash || windowHash;
};
